import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { customerAuth } from './api';

const CustomerContext = createContext(null);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    if (!customerAuth.isLoggedIn()) { setCustomer(null); setChecking(false); return; }
    try {
      const me = await customerAuth.me();
      setCustomer(me);
    } catch {
      customerAuth.logout();
      setCustomer(null);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const c = await customerAuth.login(email, password);
    setCustomer(c);
    return c;
  };
  const register = async (payload) => {
    const c = await customerAuth.register(payload);
    setCustomer(c);
    return c;
  };
  const logout = () => { customerAuth.logout(); setCustomer(null); };
  const updateProfile = async (payload) => {
    const c = await customerAuth.updateMe(payload);
    setCustomer(c);
    return c;
  };
  const verifyEmailConfirm = async (otp) => {
    const c = await customerAuth.verifyEmailConfirm(otp);
    setCustomer(c);
    return c;
  };

  return (
    <CustomerContext.Provider value={{ customer, checking, login, register, logout, updateProfile, verifyEmailConfirm, refresh }}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => {
  const ctx = useContext(CustomerContext);
  if (!ctx) throw new Error('useCustomer must be used within CustomerProvider');
  return ctx;
};
